export default "__VITE_ASSET__D$Qoc7JL__"